import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "./App.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

console.log("[app] bootstrap");

const el = document.getElementById("root");
if (!el) {
  console.error("[app] #root missing — cannot mount React");
} else {
  const root = ReactDOM.createRoot(el);
  root.render(<App />);
}

serviceWorkerRegistration.register();
